/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { RepeatingAttendancesControllerService } from './services/repeating-attendances-controller.service';
import { CollectiveBillingControllerService } from './services/collective-billing-controller.service';
import { CustomerBillableServicesLongAgoControllerService } from './services/customer-billable-services-long-ago-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    RepeatingAttendancesControllerService,
    CollectiveBillingControllerService,
    CustomerBillableServicesLongAgoControllerService,
    ApiConfiguration
  ],
})
export class CustomersBillingModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<CustomersBillingModule> {
    return {
      ngModule: CustomersBillingModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: CustomersBillingModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CustomersBillingModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
